module.exports = __webpack_public_path__ + "img/10_71.12dce834.png";